/* tslint:disable */
export enum UserCardFieldSource {
  RBBRole = 1,
  MiraRole = 2,
}
